export enum TicketValidationStatus {
    UNKNOWN,
    SUCCESS,
    WARNING,
    ERROR
}